module.exports = __webpack_public_path__ + "img/jingrong.f29b5bf9.png";